module.exports = __webpack_public_path__ + "images/emoji/card_index.14f29129f068297463e6.png";